import React, { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Alert from "react-bootstrap/Alert";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Select from "react-select";
import { Country } from "country-state-city";
import HeaderFour from "../common/header/HeaderFour";
import FooterOne from "../common/footer/FooterOne";
import { initializeApp } from "firebase/app";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import API_BASE_URL from "./../common/config";
import API_URL_dash from "../common/config2";
import API_URL from "../common/config";
import {
  ErrorNotification,
  SuccessNotification,
} from "../tosterNotification/tosters";
import SEO from "../common/SEO";
import axios from "axios";

// Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyBAMtvrbKK1p7hTG1V2AYz2bpGpGDcUAMQ",
  authDomain: "clifai-cd683.firebaseapp.com",
  projectId: "clifai-cd683",
  storageBucket: "clifai-cd683.firebasestorage.app",
  messagingSenderId: "1001395506359",
  appId: "1:1001395506359:web:a819d14200c1de7aae5132",
  measurementId: "G-YH75BT5LTN",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Custom Select Styles
const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: "38px",
    height: "38px",
    border: state.isFocused ? "1px solid #80bdff" : "1px solid #ced4da",
    borderRadius: "0.375rem",
    boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : "none",
    backgroundColor: "#fff",
    fontSize: "1rem",
    fontWeight: "400",
    lineHeight: "1.5",
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "2px 8px",
    height: "36px",
    display: "flex",
    alignItems: "center",
  }),
  input: (provided) => ({
    ...provided,
    margin: "0",
    padding: "0",
    height: "36px",
    position: "absolute",
  }),
  placeholder: (provided) => ({
    ...provided,
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    margin: "0",
    color: "#6c757d",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  singleValue: (provided) => ({
    ...provided,
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    margin: "0",
    padding: "0",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: "0 8px",
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    position: "absolute",
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: "150px",
    overflowY: "auto",
    padding: 0,
  }),
  option: (provided) => ({
    ...provided,
    fontSize: "1rem",
    padding: "0.5rem 0.75rem",
    color: "#000",
    cursor: "pointer",
  }),
};

// Options for select fields
const countries = Country.getAllCountries();
const countryOption = countries.map((country) => ({
  value: country.isoCode,
  label: country.name,
}));

const ageOptions = [
  "Below 18",
  "18 – 25",
  "26 – 34",
  "35 – 45",
  "46 – 55",
  "56 and above",
].map((age) => ({
  value: age,
  label: age,
}));

const employers = [
  "Fortune 500 / Large Multinational Corporation (MNC)",
  "Mid-Sized Enterprise (500–5000 Employees)",
  "Small & Medium Enterprise (SME) (<500 Employees)",
  "Startup / Early-Stage Company",
  "Government / Public Sector",
  "Non-Profit / NGO",
  "Education & Research (School, University, R&D)",
  "Freelancer / Self-Employed / Consultant",
  "Not Employed",
].map((employ) => ({ label: employ, value: employ }));

const roles = [
  "Not Applicable",
  "Freelancer / Self-Employed / Entrepreneur",
  "Research & Education",
  "Creative & Design",
  "Sales & Marketing",
  "Business & Strategy",
  "Technical / Engineering",
  "Managerial",
  "Executive / C-Suite",
  "Public Service",
].map((role) => ({ value: role, label: role }));

const Loader = () => (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    }}
  >
    <div
      style={{
        backgroundColor: "white",
        padding: "2rem",
        borderRadius: "8px",
        textAlign: "center",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div
        className="spinner-border text-primary"
        role="status"
        style={{ width: "3rem", height: "3rem" }}
      >
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="mt-3 mb-0">Uploading your profile...</p>
    </div>
  </div>
);

const UniversityStudentLogin = () => {
  const form = useRef();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [result, showResult] = useState(false);

  // Modal and form states
  const [showModal, setShowModal] = useState(false);
  const [userData, setUserData] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [isUploading, setIsUploading] = useState(false);

  // File upload form data
  const [formData, setFormData] = useState({
    resume: null,
    desired_country: null,
    desired_employer: null,
    desiredRole: null,
    age: null,
    dreamJobGoal: "",
  });

  const [formErrors, setFormErrors] = useState({});

  const handleManualLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        `${API_BASE_URL}/university/student-login`,
        {
          email,
          password,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      const result = response.data;
      const universityData = result.data;
      const token = result.token || "";
      const refreshToken = result.refreshToken || "";

      localStorage.setItem("universityData", JSON.stringify(universityData));
      localStorage.setItem("universityId", universityData._id);
      localStorage.setItem("studentId", universityData._id);
      localStorage.setItem("token", token);
      localStorage.setItem("refreshToken", refreshToken);

      SuccessNotification("Student Login Successfully");

      // Check if resume is submitted
      if (response.data.data.is_resumeSubmitted) {
        // Navigate directly to dashboard
        const userDataEncoded = encodeURIComponent(
          JSON.stringify(universityData)
        );
        const tokenEncoded = encodeURIComponent(JSON.stringify(token));
        const refreshTokenEncoded = encodeURIComponent(
          JSON.stringify(refreshToken)
        );

        window.location.href = `${API_URL_dash}/dashboard?userData=${userDataEncoded}&userId=${universityData._id}&token=${tokenEncoded}&refreshToken=${refreshTokenEncoded}`;
      } else {
        // Show modal for file upload
        setUserData(universityData);
        setShowModal(true);
      }
    } catch (err) {
      console.log("error", err);

      const status = err.response?.status;
      const message = err.response?.data?.message || err.message;

      if (status === 403) {
        ErrorNotification(
          "Your account is not verified yet. Please contact your admin."
        );
        setError("Your account is not verified yet :(");
      } else if (status === 401) {
        ErrorNotification("Invalid email or password");
        setError("Invalid email or password");
      } else {
        ErrorNotification(message);
        setError(message);
      }
    }
  };

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    const newValue = name === "resume" ? files[0] : value;

    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));

    if (newValue) {
      setFormErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
    }
  };

  // Handle select changes
  const handleSelectChange = (selectedOption, { name }) => {
    setFormData((prev) => ({
      ...prev,
      [name]: selectedOption,
    }));

    if (selectedOption) {
      setFormErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
    }
  };

  // Validate form
  const validateForm = () => {
    const newErrors = {};

    if (!formData.resume) newErrors.resume = "Resume is required.";
    if (!formData.dreamJobGoal.trim())
      newErrors.dreamJobGoal = "Dream job goal is required.";

    setFormErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle file upload form submission
  const handleFileUploadSubmit = async (e) => {
    if (e) e.preventDefault();

    console.log("Form submission started...");
    console.log("Current form data:", formData);

    if (validateForm()) {
      setSubmitting(true);
      setIsUploading(true);

      const formDataToSend = new FormData();
      formDataToSend.append("resume", formData.resume);
      formDataToSend.append("desired_country", "IN");
      formDataToSend.append(
        "desired_employer",
        "Fortune 500 / Large Multinational Corporation (MNC)"
      );
      formDataToSend.append("desiredRole", "Technical / Engineering");
      formDataToSend.append("dreamJobGoal", formData.dreamJobGoal);
      formDataToSend.append("userId", localStorage.getItem("studentId"));

      console.log("Form data being sent:", {
        resume: formData.resume?.name,
        desired_country: "IN",
        desired_employer: "Fortune 500 / Large Multinational Corporation (MNC)",
        desiredRole: "Technical / Engineering",
        dreamJobGoal: formData.dreamJobGoal,
        userId: localStorage.getItem("studentId"),
      });

      try {
        console.log(
          "Making API call to:",
          `${API_BASE_URL}/university/resumeFile`
        );

        const response = await axios.post(
          `${API_BASE_URL}/university/resumeFile`,
          formDataToSend,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        console.log("API Response:", response.data);

        if (response.data.success) {
          localStorage.setItem(
            "user",
            JSON.stringify(response.data.university_student)
          );
          localStorage.setItem("sUserid", response.data.university_student._id);

          SuccessNotification("Profile setup completed successfully!");
          setShowModal(false);

          // Navigate to dashboard
          const userDataEncoded = encodeURIComponent(JSON.stringify(userData));
          const token = localStorage.getItem("token");
          const refreshToken = localStorage.getItem("refreshToken");
          const tokenEncoded = encodeURIComponent(JSON.stringify(token));
          const refreshTokenEncoded = encodeURIComponent(
            JSON.stringify(refreshToken)
          );

          window.location.href = `${API_URL_dash}/dashboard?userData=${userDataEncoded}&userId=${userData._id}&token=${tokenEncoded}&refreshToken=${refreshTokenEncoded}`;
        }
      } catch (error) {
        console.error("API Error:", error);
        console.error("Error response:", error.response?.data);
        const errorMessage =
          error.response?.data?.message ||
          "Something went wrong. Please try again.";
        ErrorNotification("Error", errorMessage);
      } finally {
        setSubmitting(false);
        setIsUploading(false);
      }
    } else {
      console.log("Form validation failed:", formErrors);
    }
  };

  // Close modal
  const handleCloseModal = () => {
    // Prevent closing modal while uploading
    if (isUploading) {
      return;
    }

    setShowModal(false);
    setFormData({
      resume: null,
      desired_country: null,
      desired_employer: null,
      desiredRole: null,
      age: null,
      dreamJobGoal: "",
    });
    setFormErrors({});
  };

  setTimeout(() => {
    showResult(false);
  }, 5000);

  return (
    <>
      <SEO />
      {isUploading && <Loader />}
      <main className="main-wrapper">
        <HeaderFour />
        <div
          className="section section-padding"
          style={{ position: "relative" }}
        >
          <div className="container mt-5">
            <div className="row justify-content-center">
              <div className="col-xl-5 col-lg-6">
                <div className="contact-form-box shadow-box">
                  <h3 className="title text-center">Student Login</h3>
                  <h5 className="text-center">
                    Don't have access? &nbsp;{" "}
                    <span
                      style={{ color: "#6600CC", textDecoration: "underline" }}
                    >
                      Request Access
                    </span>
                  </h5>
                  {error && <Alert variant="danger">{error}</Alert>}
                  <form
                    ref={form}
                    onSubmit={handleManualLogin}
                    className="axil-contact-form"
                  >
                    <div className="form-group">
                      <label>Email address*</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="student@gmail.com"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Password*</label>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="******"
                        name="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group gap-2 flex-row">
                      <button
                        type="submit"
                        className="axil-btn try-free-btn btn-fluid btn-primary"
                        name="submit-btn"
                      >
                        Log In
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <ul className="shape-group-8 list-unstyled">
            <li className="shape shape-1">
              <img
                src={process.env.PUBLIC_URL + "/images/others/bubble-9.png"}
                alt="Bubble"
              />
            </li>
            <li className="shape shape-2">
              <img
                src={process.env.PUBLIC_URL + "/images/others/bubble-11.png"}
                alt="Bubble"
              />
            </li>
            <li className="shape shape-3">
              <img
                src={process.env.PUBLIC_URL + "/images/others/line-4.png"}
                alt="Line"
              />
            </li>
          </ul>
        </div>
        <FooterOne />

        {/* File Upload Modal */}
        <Modal
          show={showModal}
          onHide={handleCloseModal}
          size="lg"
          backdrop="static"
          keyboard={false}
          style={{ marginTop: "12%" }}
        >
          <Modal.Header
            closeButton={!isUploading}
            style={{ backgroundColor: "#6600CC", color: "white" }}
          >
            <Modal.Title>Complete Your Profile Setup</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="text-center mb-4">
              We need some information to setup your profile
            </p>
            <div>
              <div className="row">
                <div className="col-lg-12 mb-3">
                  <label className="form-label">Upload your CV*</label>
                  <input
                    type="file"
                    accept=".pdf,.doc,.docx"
                    className={`form-control ${
                      formErrors.resume ? "is-invalid" : ""
                    }`}
                    name="resume"
                    onChange={handleChange}
                    disabled={isUploading}
                  />
                  {formErrors.resume && (
                    <div className="invalid-feedback">{formErrors.resume}</div>
                  )}
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">Dream Job Goal*</label>
                <textarea
                  className={`form-control ${
                    formErrors.dreamJobGoal ? "is-invalid" : ""
                  }`}
                  name="dreamJobGoal"
                  placeholder="Enter your dream job goal..."
                  rows={4}
                  value={formData.dreamJobGoal}
                  onChange={handleChange}
                  disabled={isUploading}
                />
                {formErrors.dreamJobGoal && (
                  <div className="invalid-feedback">
                    {formErrors.dreamJobGoal}
                  </div>
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-center gap-3">
            <Button
              variant="outline"
              onClick={handleCloseModal}
              disabled={submitting || isUploading}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleFileUploadSubmit}
              disabled={submitting || isUploading}
              style={{
                backgroundColor: "#6600CC",
                borderColor: "#6600CC",
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "#006600";
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = "#6600CC";
              }}
            >
              {submitting ? "Submitting..." : "Submit"}
            </Button>
          </Modal.Footer>
        </Modal>
      </main>
    </>
  );
};

export default UniversityStudentLogin;
